import React, { useRef, useEffect } from "react";

/**
 * Wraps popover content and observes its size in status update popover and raise escalation confirmation popover. 
 * When the content resizes due to more text in Input field, it calls the popover's updatePosition
 * so the popover can reposition itself and avoid misalignment or viewport overflow.
 */

export const PopoverContentWithResizeObserver: React.FC<{
    actionRef: React.RefObject<{ updatePosition: () => void } | null>;
    open: boolean;
    children: React.ReactNode;
}> = ({ actionRef, open, children }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open || !wrapperRef.current || !actionRef?.current) return;
        const el = wrapperRef.current;
        const resizeObserver = new ResizeObserver(() => {
            actionRef.current?.updatePosition?.();
        });
        resizeObserver.observe(el);
        return () => resizeObserver.disconnect();
    }, [open, actionRef]);

    return <div ref={wrapperRef}>{children}</div>;
};

